import { StateCreator } from 'zustand';

import { CommonStoreType, PlayerState } from '../types';

export const usePlayerSlice: StateCreator<
  CommonStoreType,
  [],
  [],
  PlayerState
> = () => {
  return {
    playerFields: undefined,
    playerSettings: undefined,
  };
};
